export const Bio = {
    name: "Hariprasath C",
    roles: [
      " Java Full Stack Developer",
      "Web Developer",
      "Programmer",
    ],
    description:
      "I am a motivated and versatile individual, always eager to take on new challenges. With a passion for learning I am dedicated to delivering high-quality results. With a positive attitude and a growth mindset, I am ready to make a meaningful contribution and achieve great things.",
    github: "https://github.com/hariprasath8111",
    resume:
      "https://drive.google.com/file/d/1sGGU3LkTZtsGYMRqESoHP1fj7mDJYrPe/view?usp=sharing",
    linkedin: "www.linkedin.com/in/hariprasath-c-063071237",
    insta: "",
    
  };
  
  export const skills = [
    {
      title: "Frontend",
      skills: [
        {
          name: "React Js",
          image:
            "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9Ii0xMS41IC0xMC4yMzE3NCAyMyAyMC40NjM0OCI+CiAgPHRpdGxlPlJlYWN0IExvZ288L3RpdGxlPgogIDxjaXJjbGUgY3g9IjAiIGN5PSIwIiByPSIyLjA1IiBmaWxsPSIjNjFkYWZiIi8+CiAgPGcgc3Ryb2tlPSIjNjFkYWZiIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIi8+CiAgICA8ZWxsaXBzZSByeD0iMTEiIHJ5PSI0LjIiIHRyYW5zZm9ybT0icm90YXRlKDYwKSIvPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIiB0cmFuc2Zvcm09InJvdGF0ZSgxMjApIi8+CiAgPC9nPgo8L3N2Zz4K",
        },
        {
          name: "Redux",
          image:
            "https://d33wubrfki0l68.cloudfront.net/0834d0215db51e91525a25acf97433051f280f2f/c30f5/img/redux.svg",
        },
       
        {
          name: "HTML",
          image: "https://www.w3.org/html/logo/badge/html5-badge-h-solo.png",
        },
        {
          name: "CSS",
          image:
            "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d5/CSS3_logo_and_wordmark.svg/1452px-CSS3_logo_and_wordmark.svg.png",
        },
        {
          name: "JavaScript",
          image:
            "https://upload.wikimedia.org/wikipedia/commons/thumb/6/6a/JavaScript-logo.png/800px-JavaScript-logo.png",
        },
        {
          name: "Bootstrap",
          image:
            "https://getbootstrap.com/docs/5.3/assets/brand/bootstrap-logo-shadow.png",
        },
       
      ],
    },
    {
      title: "Backend",
      skills: [
        {
          name: "Java",
          image: "https://raw.githubusercontent.com/devicons/devicon/master/icons/java/java-original.svg",
        },
        {
          name: "Spring Boot",
          image:
            "https://img.icons8.com/?size=48&id=90519&format=png",
        },
        {
          name: "Oracle Sql",
          image: "https://e7.pngegg.com/pngimages/1021/283/png-clipart-microsoft-sql-server-oracle-database-oracle-corporation-sql-logo-purple-text-thumbnail.png",
        },
      ],
    },
   
    {
      title: "Others",
      skills: [
        {
          name: "Git",
          image:
            "https://w7.pngwing.com/pngs/192/492/png-transparent-git-bash-hd-logo-thumbnail.png",
        },
        {
          name: "GitHub",
          image:
            "https://github.githubassets.com/images/modules/logos_page/GitHub-Mark.png",
        },
        {
          name: "Eclipse",
          image:
            "https://w7.pngwing.com/pngs/631/720/png-transparent-eclipse-foundation-integrated-development-environment-ceylon-java-eclipse-miscellaneous-logo-electric-blue-thumbnail.png",
        },
        {
          name: "Netlify",
          image:
            "https://seeklogo.com/images/N/netlify-logo-BD8F8A77E2-seeklogo.com.png",
        },
        {
          name: "VS Code",
          image:
            "https://upload.wikimedia.org/wikipedia/commons/thumb/9/9a/Visual_Studio_Code_1.35_icon.svg/512px-Visual_Studio_Code_1.35_icon.svg.png?20210804221519",
        },
        {
          name: "Postman",
          image:
            "https://w7.pngwing.com/pngs/28/245/png-transparent-postman-hd-logo-thumbnail.png",
        },
      ],
    },
  ];
  
  export const experiences = [
    {
      id: 0,
      img: "https://media.licdn.com/dms/image/v2/D4D0BAQFsM4OuVleklg/company-logo_200_200/company-logo_200_200/0/1702576029790?e=2147483647&v=beta&t=Mtvoveo1GPPJelnZTfouTMcNppRqPI53jn_is0AFn4I",
      role: "Web Development Intern",
      company: "VeriTech Software IT Services",
      date: "Jan 2024 - April 2024",
      desc: "Working on Flipr Platforms, managing DevOps, and streamlining the process with automation.",
      skills: [
        "HTML",
        "CSS",
        "JavaScript",
        "GitHub",
      ],
      doc: "https://drive.google.com/file/d/11PW1tz75x-wF8dsAL0quvrqrTgB2BmKc/view?usp=sharing",
    },
    {
      id: 0,
      img: "https://media.licdn.com/dms/image/v2/C4E0BAQHWgv26_a460Q/company-logo_200_200/company-logo_200_200/0/1638253642615/tehchnosprint_info_solutions_logo?e=2147483647&v=beta&t=JU8tUqMjja2XoTLN_8t_tT5szLkuKhYNnnxngfDD6IA",
      role: "Frontend Intern",
      company: "Technosprint Info Solutions",
      date: "Dec 2022 - Jan 2023",
      desc: "Working on the frontend of the web application.",
      skills: [
        "HTML",
        "CSS",
        "JavaScript",
      ],
      doc: "https://drive.google.com/file/d/11_UWPwxQ1kiuodT9oVm9A7Di4xAvu4ST/view?usp=drive_link",
    },
 
  ];
  
  export const education = [
    {
      id: 0,
      img: "data:image/jpeg;base64,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",
      school: "IFET College of Engineering,Villupuram",
      date: "Aug 2019 - May 2023",
      grade: "7.41 CGPA",
      desc: "I am currently pursuing a Bachelor's degree in Computer Science and Engineering at Kalinga Institute of Industrial Technology, Bhubaneswar. I have completed 4 semesters and have a CGPA of 8.71. I have taken courses in Data Structures, Algorithms, Object-Oriented Programming, Database Management Systems, Operating Systems, and Computer Networks, among others. I am also a member of the Google Developers Student Club (GDSC) at KIIT, where I am learning and working on exciting projects with a team of talented developers.",
      degree: "Bachelor of Engineering - Electronics and Communication Engineering",
    },
    {
      id: 1,
      img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRPk9-_h8CL8D4zlnlQHxsyKfdOjThx04W07Lf32JDsMg&s",
      school: "S.R.K Higher Secondary School,Puducherry",
      date: "Apr 2018 - Apr 2019",
      grade: "74%",
      desc: "I completed my class 12 high school education at Methodist School, Dankuni, where I studied Science with Computer Science.",
      degree: "XII, Computer Scince",
    },
    {
      id: 2,
      img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRPk9-_h8CL8D4zlnlQHxsyKfdOjThx04W07Lf32JDsMg&s",
      school: "S.R.K Higher Secondary School,Puducherry",
      date: "Apr 2016 - Apr 2017",
      grade: "90%",
      desc: "I completed my class 10 education at Methodist School, Dankuni, where I studied Science with Computer Application.",
      degree: "X, State Board",
    },
  ];
  
  export const projects = [
    {
      id: 9,
      title: "Trackify",
      date: "Jun 2023 - Jul 2023",
      description:
        "Trackify is a web application designed to streamline task management and enhance productivity in the workplace. It provides a user-friendly interface for employers to keep track of their employees' daily work activities and empowers employees to log their tasks efficiently. \nAdmin Credentials: # Email: testadmin@gmail.com #Password- 123@testadmin, Employee Credentials:	#Email: testemployee@gmail.com	#Password- 123@Testemployee",
      image:
        "https://user-images.githubusercontent.com/64485885/255202416-e1f89b04-2788-45b0-abc2-9dec616669e2.png",
      tags: [
        "Docker",
        "AWS",
        "DuckDNS",
        "Eslint",
        "Husky",
        "CI/CD",
        "React Js",
        "MongoDb",
        "Node Js",
        "Express Js",
        "Redux",
      ],
      category: "web app",
      github: "https://github.com/rishavchanda/Trackify",
      webapp: "https://trackify.duckdns.org",
    },
    {
      id: 1,
      title: "Vexa",
      date: "Oct 2022 - Present",
      description:
        "Designed and developed the Vexa project, a project management app that helps users and teams stay organized and on track. Implemented key features such as task tracking, team collaboration, and time tracking to improve productivity and project outcomes and also invite team/project members. The plan is to add a community of users where they can find developers and other team members and chat system implementation.",
      image:
        "https://user-images.githubusercontent.com/64485885/234916413-96296f13-fe4b-4cc4-b215-e72bd7c27928.png",
      tags: [
        "React Js",
        "MongoDb",
        "Node Js",
        "Express Js",
        "Redux",
        "NodeMailer",
      ],
      category: "web app",
      github: "https://github.com/rishavchanda/Project-Management-App",
      webapp: "https://vexa-app.netlify.app/",
    },
    {
      id: 2,
      title: "Netflix Sign ",
      date: "Jan 2023 - Mar 2023",
      description:
        "Preprocessed and augmented the dataset to improve model accuracy, trained the model, created API using model and Python, and used React web app for the project's front end. Achievements: Achieved an accuracy of 99.2% to accurately detect brain tumors from medical images.",
      image:
        "https://tse1.mm.bing.net/th?id=OIP.3FCiWol8fLRLFWVRP1SpMAHaEK&pid=Api",
      tags: ["HTML", "CSS",],
      category: "machine learning",
      github: "https://hariprasath8111.github.io/Netflix/",
      webapp: "https://musical-hotteok-e01381.netlify.app",

    },
    {
      id: 3,
      title: "To- Do App",
      date: "Dec 2021 - Apr 2022",
      description:
        "App Is Currently In Playstore 100+ Downloads. This Project proposes an “Expense Tracking App”. Keep track of your personal expenses and compare them to your monthly income with the budget planner. It has Google Drive Cloud API for Backup of User Room Database. Made with Kotlin in MVVM Architecture & Live Data.",
      image:
        "https://camo.githubusercontent.com/fbf405040ae86b5d4a40f24e4ac034982cb8c0e2d850560ba64527997b258be8/68747470733a2f2f666972656261736573746f726167652e676f6f676c65617069732e636f6d2f76302f622f6c6f67696e2d65613565322e61707073706f742e636f6d2f6f2f4255434b4f49442532302831292e706e673f616c743d6d6564696126746f6b656e3d32653735376235372d323964372d346263612d613562322d653164346538313432373435",
      tags: ["Kotlin", "MVVM", "Room Database", "Google Drive Cloud API"],
      category: "android app",
      github: "https://hariprasath8111.github.io/Todo-list/",
      webapp: "https://celadon-taiyaki-99c3b6.netlify.app",
    },
    {
      id: 10,
      title: "Job Finding App",
      date: "Jun 2023 - Jul 2023",
      description:
        "A Job Finding App made with React Native, Axios. Users can search for any job coming from API and apply there.",
      image:
        "https://user-images.githubusercontent.com/64485885/255237090-cf798a2c-1b41-4bb7-b904-b5353a1f08e8.png",
      tags: ["React Native", "JavaScript", "Axios"],
      category: "android app",
      github: "https://github.com/rishavchanda/Job-finder-App",
      webapp: "https://github.com/rishavchanda/Job-finder-App",
    },
    {
      id: 4,
      title: "Whatsapp Clone",
      date: "Jul 2021",
      description:
        "A WhatsApp clone made with React JS, Firebase, and Material UI. It has Phone Authentication, Real-time Database. It has a chat room where users can chat with each other. It has a sidebar where users can see all the chat rooms and can create a new chat room. It has a login page where users can log in with their Google account.",
      image:
        "https://firebasestorage.googleapis.com/v0/b/whatsapp-clone-rishav.appspot.com/o/Screenshot%20(151).png?alt=media&token=48391593-1ef0-4a8c-a92a-eb82bdf38e89",
      tags: ["React Js", "Firebase", "Firestore", "Node JS"],
      category: "web app",
      github: "https://github.com/rishavchanda/Whatsapp-Clone-React-Js",
      webapp: "https://whatsapp-clone-rishav.web.app",
    },
    {
      id: 5,
      title: "Todo Web App",
      date: "Jun 2021",
      description:
        " A Todo Web App made with React JS, Redux, and Material UI. It has a login page where users can log in with their Google account. It has a sidebar where users can see all the tasks and can create a new task. It has a calendar where users can see all the tasks on a particular date. It has a search bar where users can search for a particular task.",
      image:
        "https://camo.githubusercontent.com/a328255ad96f861f57d25096d28018ab2656c689a1456b0d145764009bed2d1a/68747470733a2f2f666972656261736573746f726167652e676f6f676c65617069732e636f6d2f76302f622f746f646f2d6170702d63386331392e61707073706f742e636f6d2f6f2f53637265656e73686f74253230283938292e706e673f616c743d6d6564696126746f6b656e3d33643335646366322d626666322d343730382d393031632d343232383866383332386633",
      tags: ["React Js", "Local Storage", "AWS Auth", "Node JS"],
      category: "web app",
      github: "https://github.com/rishavchanda/Todo-Web-App",
      webapp: "https://rishav-react-todo.netlify.app/",
    },
    {
      id: 6,
      title: "Breaking Bad",
      date: "Jun 2021",
      description:
        "A simple react app that shows the characters of the famous TV series Breaking Bad. It uses the Breaking Bad API to fetch the data. It also has a search bar to search for a particular character.",
      image:
        "https://camo.githubusercontent.com/cd07010cbeb90cb1b43a5d6162784326aef02210ef7d41a0f9ae043b3e392378/68747470733a2f2f666972656261736573746f726167652e676f6f676c65617069732e636f6d2f76302f622f746f646f2d6170702d63386331392e61707073706f742e636f6d2f6f2f53637265656e73686f7425323028313534292e706e673f616c743d6d6564696126746f6b656e3d65613439383630632d303435362d343333342d616435372d336239346663303333363263",
      tags: ["React Js", "API", "Axios", "Node JS"],
      category: "web app",
      github: "https://github.com/rishavchanda/Breaking-Bad",
      webapp: "https://breaking-bad-webapp.netlify.app",
    },
    {
      id: 7,
      title: "Quiz App",
      date: "Dec 2020 - Jan 2021",
      description:
        "A android quiz app made with Java and Firebase. It has a login page where users can log in with their Google account. It has a sidebar where users can see all the quiz categories and can create a new quiz. It has a leaderboard where users can see the top 10 scorers. It has a search bar where users can search for a particular quiz.",
      image:
        "https://github-production-user-asset-6210df.s3.amazonaws.com/64485885/239726262-c1b061d1-d9d0-42ef-9f1c-0412d14bc4f6.gif",
      tags: ["Java", "Android Studio", "Firebase", "Google Auth"],
      category: "android app",
      github: "https://github.com/rishavchanda/Quiz-Earn",
      webapp: "https://github.com/rishavchanda/Quiz-Earn",
    },
    {
      id: 8,
      title: "Face Recognition",
      date: "Jan 2021",
      description:
        "A Face recognition python app made with OpenCV. It uses face_recognition library to detect faces. It uses the webcam to detect faces. It also has a search bar to search for a particular face.",
      image:
        "https://camo.githubusercontent.com/a8b3e1ebf26d4c95f75bc6671189a3590eb67eb8332d7c7452492990e731efb9/68747470733a2f2f77617265686f7573652d63616d6f2e696e67726573732e636d68312e707366686f737465642e6f72672f356137383335396561323762643261633232336437656662306639303831306437373930383436312f363837343734373037333361326632663633366336663735363432653637363937343638373536323735373336353732363336663665373436353665373432653633366636643266363137333733363537343733326633383339333633363339333232663332333433343333333033333339333832663333333636363330363533333636333032643331333336333632326433313331363533373264333833323335333832643334363433303633333936333635333136353334333133393265363736393636",
      tags: ["Python", "Keras", "TensorFlow", "VGG16", "Pickle", "React"],
      category: "machine learning",
      github: "https://github.com/rishavchanda/Face-Recodnition-AI-with-Python",
      webapp: "https://github.com/rishavchanda/Face-Recodnition-AI-with-Python",
    },
  ];
  
  // export const TimeLineData = [
  //   { year: 2017, text: "Started my journey" },
  //   { year: 2018, text: "Worked as a freelance developer" },
  //   { year: 2019, text: "Founded JavaScript Mastery" },
  //   { year: 2020, text: "Shared my projects with the world" },
  //   { year: 2021, text: "Started my own platform" },
  // ];